import 'styles/custom.css';
import * as React from 'react';
import { StandardScreen } from 'components/Layout/ScreenWrapper.jsx';
import {getFilteredLogs, getEndpoints } from "../components/Requests/Requests";
import {
    StandardSearchBox,
    StandardDropdown,
    StandardTextField,
    StandardButton,
    StatusMessage,
    StandardText,
    TextFieldWithTooltip,
    ButtonWithTooltip,
} from '../components/Layout/FormComponents.jsx';
import { PageLayout } from 'components/Layout';
import theme from '../styles/theme.js';
import Theme from '../styles/theme.js';

class Logs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //Get all logs
            existingLogs: "",

            //Filter logs
            filterEndpoint: "",
            filterUser: "",
            filterSPHostUrl: "",
            filterStartDate: null,
            filterEndDate: null,

            //Order logs
            orderBy: "",
            orderDirection: "",

            //Paging - copied from Statistics
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            totalPages: 0,

            //Loading
            loading: false,
            error: "",
            message: "",

            // Table data - copied from Statistics
            tableRows: "",
            tableHeaders: "",

            // Get list of endpoints
            existingEndpoints: ""
        }
    }

    componentDidMount() {
        this.initializeSettings();
    }

    initializeSettings() {
        this.getEndpoints();
    }

    async getFilteredLogs() {
        this.setState({loading: true, error: "", message: ""})

        try{ 
            let requestBody = {
                Endpoint: this.state.filterEndpoint,
                User: this.state.filterUser,
                SPHostUrl: this.state.filterSPHostUrl,
                StartDate: this.state.filterStartDate === "" ? null : this.state.filterStartDate,
                EndDate: this.state.filterEndDate === "" ? null : this.state.filterEndDate,
                OrderBy: this.state.orderBy,
                OrderDirection: this.state.orderDirection,

                //Pagination - copied from Statistics
                PageNumber: this.state.currentPage,
                PageSize: this.state.pageSize
            };

            let response = await getFilteredLogs(this.props.accessToken, requestBody);

            if (response.status === 200) {
                let data = await response.json();

                if (!data.logs || data.logs.length === 0) {
                    this.setState({
                        loading: false,
                        error: "There are no logs matching this criteria",
                        tableRows: "",
                        tableHeaders: "",
                        totalCount: 0,
                        totalPages: 0,
                        currentPage: 1
                    });
                } else {
                    const totalCount = data.totalCount || 0;
                    const totalPages = Math.ceil(totalCount / this.state.pageSize);
                    let tableHeaders = this.renderTableHeaders(data.logs);
                    let tableRows = this.renderTableRows(data.logs);
                    
                    this.setState({
                        loading: false,
                        tableRows: tableRows,
                        tableHeaders: tableHeaders,
                        totalCount: totalCount,
                        totalPages: totalPages,
                        existingLogs: data.logs
                    });
                }
            } else {
                this.setState({
                    loading: false,
                    error: "Something went wrong",
                    message: "",
                    totalCount: 0,
                    totalPages: 0,
                    currentPage: 1,
                    tableRows: "",
                    tableHeaders: ""
                });
            }
        } catch (error) {
            this.setState({
                loading: false,
                error: "Failed to fetch logs",
                message: "",
                totalCount: 0,
                totalPages: 0,
                currentPage: 1,
                tableRows: "",
                tableHeaders: ""
            });
        }
    }

    // Pagination methods - copied exactly from Statistics
    handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= this.state.totalPages) {
            this.setState({ currentPage: newPage }, () => this.getFilteredLogs());
        }
    };

    handlePreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.handlePageChange(this.state.currentPage - 1);
        }
    };

    handleNextPage = () => {
        if (this.state.currentPage < this.state.totalPages) {
            this.handlePageChange(this.state.currentPage + 1);
        }
    };

    renderPageNumbers = () => {
        const { currentPage, totalPages } = this.state;
        const pageNumbers = [];
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, startPage + 4);
        if (endPage - startPage < 4) {
            startPage = Math.max(1, endPage - 4);
        }
        if (startPage > 1) {
            pageNumbers.push(
                <StandardButton 
                    key={1} 
                    text="1" 
                    onClick={() => this.handlePageChange(1)}
                    disabled={1 === currentPage}
                />
            );
            if (startPage > 2) {
                pageNumbers.push(<span key="ellipsis1" style={{ margin: '0 5px' }}>...</span>);
            }
        }
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <StandardButton
                    key={i}
                    text={String(i)}
                    onClick={() => this.handlePageChange(i)}
                    disabled={i === currentPage}
                />
            );
        }
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pageNumbers.push(<span key="ellipsis2" style={{ margin: '0 5px' }}>...</span>);
            }
            pageNumbers.push(
                <StandardButton
                    key={totalPages} 
                    text={String(totalPages)} 
                    onClick={() => this.handlePageChange(totalPages)}
                    disabled={totalPages === currentPage}
                />
            );
        }
        return pageNumbers;
    };

    // Table rendering methods - copied from Statistics approach
    renderTableHeaders(data) {
        if (!data || data.length === 0) return null;

        return (
            <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={{ border: '1px solid #ddd', padding: '8px', width: '20%', textAlign: 'center' }}>Timestamp</th>
                <th style={{ border: '1px solid #ddd', padding: '8px', width: '25%', textAlign: 'center' }}>User</th>
                <th style={{ border: '1px solid #ddd', padding: '8px', width: '15%', textAlign: 'center' }}>Endpoint</th>
                <th style={{ border: '1px solid #ddd', padding: '8px', width: '40%', textAlign: 'center' }}>Metadata</th>
            </tr>
        );
    }

    renderTableRows(data) {
        if (!data || data.length === 0) return null;

        return data.map((log, index) => (
            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                <td style={{ 
                    border: '1px solid #ddd', 
                    padding: '8px',
                    wordBreak: 'break-word'
                }}>
                    <strong>{new Date(log.timestamp).toLocaleString(navigator.language)}</strong>
                </td>
                <td style={{ 
                    border: '1px solid #ddd', 
                    padding: '8px',
                    wordBreak: 'break-word'
                }}>{log.user}</td>
                <td style={{ 
                    border: '1px solid #ddd', 
                    padding: '8px',
                    wordBreak: 'break-word'
                }}>{log.endpoint}</td>
                <td style={{ 
                    border: '1px solid #ddd', 
                    padding: '8px',
                    wordBreak: 'break-word'
                }}>
                    {log.metadata ? (
                        <div style={{ 
                            fontSize: '0.9em', 
                            color: '#666',
                            wordBreak: 'break-word',
                            whiteSpace: 'pre-wrap'
                        }}>
                            {JSON.stringify(log.metadata, null, 2)}
                        </div>
                    ) : (
                        <span style={{ fontStyle: 'italic', color: '#999' }}>No metadata</span>
                    )}
                </td>
            </tr>
        ));
    }

    async getEndpoints() {
        this.setState({ loading: true })
        let response = await getEndpoints(this.props.accessToken);

        if (response.status === 200) {
            let data = await response.json();
            this.setState({
                loading: false,
                existingEndpoints: data.map(item =>
                    ({ key: item, text: item })),
            });
        } else {
            this.setState({ loading: false, error: "Failed to retrieve endpoints."});
        }
    }

    render() {
        const {
            loading, error, message, currentPage, pageSize, totalCount, totalPages, tableRows, tableHeaders
        } = this.state;

        const orderByOptions = [
            { key: 'timestamp', text: 'Timestamp' },
            { key: 'user', text: 'User' },
            { key: 'endpoint', text: 'Endpoint' },
            { key: 'spHostUrl', text: 'SPHostURL' }
        ];

        const orderDirectionOptions = [
            { key: 'asc', text: 'Ascending' },
            { key: 'desc', text: 'Descending' }
        ];

        return (
            <PageLayout>
                <StandardScreen
                    title="Logs Dashboard"
                    description="View, filter, and sort application logs. Use the filters below to find specific log entries by endpoint, user, date range, and more."
                    loading={loading}
                >
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <StandardTextField
                            label="Endpoint"
                            value={this.state.filterEndpoint}
                            onChange={(e, value) => this.setState({ filterEndpoint: value })}
                            placeholder="Enter endpoint to filter by"
                        />

                        <StandardTextField
                            label="User"
                            value={this.state.filterUser}
                            onChange={(e, value) => this.setState({ filterUser: value })}
                            placeholder="Enter user to filter by"
                        />
                    </div>

                    <StandardTextField
                        label="SPHostURL"
                        value={this.state.filterSPHostUrl}
                        onChange={(e, value) => this.setState({ filterSPHostUrl: value })}
                        placeholder="Enter SPHostURL to filter by"
                    />

                    <br></br>

                    <div style={{ display: 'flex', gap: '20px' }}>
                        <StandardTextField
                            label="Start Date"
                            type="date"
                            value={this.state.filterStartDate}
                            onChange={(e, value) => this.setState({ filterStartDate: value })}
                        />

                        <StandardTextField
                            label="End Date"
                            type="date"
                            value={this.state.filterEndDate}
                            onChange={(e, value) => this.setState({ filterEndDate: value })}
                        />
                    </div>

                    <br></br>

                    <div style={{ display: 'flex', gap: '20px' }}>
                        <StandardDropdown
                            label="Order By"
                            options={orderByOptions}
                            selectedKey={this.state.orderBy}
                            onChange={(e, option) => this.setState({ orderBy: option.key })}
                            placeholder="Select field to order by"
                        />

                        <StandardDropdown
                            label="Order Direction"
                            options={orderDirectionOptions}
                            selectedKey={this.state.orderDirection}
                            onChange={(e, option) => this.setState({ orderDirection: option.key })}
                            placeholder="Select order direction"
                        />
                    </div>

                    <br></br>

                    <div style={{
                        display: 'flex',
                        gap: '20px' 
                    }}>
                        <StandardButton
                            text="✖ Clear Filters"
                            onClick={() => this.setState({
                                filterEndpoint: "",
                                filterUser: "",
                                filterSPHostUrl: "",
                                filterStartDate: "",
                                filterEndDate: "",
                                orderBy: "",
                                orderDirection: "",
                                currentPage: 1
                            })}
                        />

                        <ButtonWithTooltip
                            text="Get Logs"
                            onClick={() => {
                                this.setState({ currentPage: 1 });
                                this.getFilteredLogs();
                            }}
                            width='extra-wide'
                            disabled={loading}
                            tooltipContent={
                                <StandardText
                                    variant="small"
                                    color={theme.colors.primary}
                                >
                                    Get logs adhering to supplied filter values.
                                    <br></br>
                                    <br></br>
                                    <b><i>If you do not supply any, all logs will be retrieved.</i></b>
                                </StandardText>
                            }
                        />
                    </div>

                    {error && <StatusMessage type="error">{error}</StatusMessage>}
                    {message && <StatusMessage type="success">{message}</StatusMessage>}

                    {/* Table and Pagination - copied exactly from Statistics */}
                    <div style={{ margin: '20px' }}>
                        {loading ? (
                            <p>Loading...</p>
                        ) : (
                            (tableRows && tableRows.length > 0) ? (
                                <div
                                    className="table-container"
                                    style={{
                                        marginTop: Theme.spacing.lg,
                                        marginLeft: `-${Theme.layout.contentPadding}`,
                                        marginRight: `-${Theme.layout.contentPadding}`,
                                        padding: Theme.layout.contentPadding,
                                        width: `calc(100% + ${Theme.layout.contentPadding} + ${Theme.layout.contentPadding})`,
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    {/* Pagination Info */}
                                    <div style={{ 
                                        marginBottom: '15px', 
                                        display: 'flex', 
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        backgroundColor: '#f8f9fa',
                                        padding: '10px',
                                        borderRadius: '4px',
                                        border: '1px solid #dee2e6'
                                    }}>
                                        <div style={{ fontSize: '14px', color: '#6c757d' }}>
                                            {(() => {
                                                if (!tableRows || totalCount === 0) {
                                                    return 'Showing 0 to 0 of 0 logs';
                                                }
                                                const start = ((currentPage - 1) * pageSize) + 1;
                                                const end = Math.min(currentPage * pageSize, totalCount);
                                                const validStart = Math.min(start, end, totalCount);
                                                const validEnd = Math.max(validStart, end);
                                                return `Showing ${validStart} to ${validEnd} of ${totalCount} logs`;
                                            })()}
                                        </div>
                                        <div style={{ fontSize: '14px', color: '#6c757d' }}>
                                            Page {currentPage} of {totalPages}
                                        </div>
                                    </div>
                                    
                                    {/* Table */}
                                    <div style={{ overflowX: 'auto', width: '100%' }}>
                                        <table style={{ 
                                            width: '100%', 
                                            borderCollapse: 'collapse', 
                                            marginBottom: '20px',
                                            tableLayout: 'auto'
                                        }}>
                                            <thead>
                                                {tableHeaders}
                                            </thead>
                                            <tbody>
                                                {tableRows}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    {/* Pagination Controls */}
                                    {totalPages > 1 && (
                                        <div style={{ 
                                            display: 'flex', 
                                            justifyContent: 'center', 
                                            alignItems: 'center',
                                            gap: '10px',
                                            marginTop: '20px',
                                            padding: '15px',
                                            backgroundColor: '#f8f9fa',
                                            borderRadius: '4px',
                                            border: '1px solid #dee2e6'
                                        }}>
                                            <StandardButton
                                                text="Previous"
                                                disabled={currentPage === 1}
                                                onClick={this.handlePreviousPage}
                                            />
                                            
                                            <div style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                gap: '5px',
                                                margin: '0 15px'
                                            }}>
                                                {this.renderPageNumbers()}
                                            </div>

                                            <StandardButton
                                                text="Next"
                                                disabled={currentPage === totalPages}
                                                onClick={this.handleNextPage}
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <p></p>
                            )
                        )}
                    </div>
                </StandardScreen>
            </PageLayout>
        );
    }
}

export default Logs;
